import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/frontru/aquaart-group/node_modules/antd/lib/config-provider/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["SkeletonTheme"] */ "/home/frontru/aquaart-group/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/node_modules/swiper/modules/navigation.css");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/components/entities/footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/components/entities/layout/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/node_modules/swiper/swiper-bundle.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/core/providers/store-provider.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/core/styles/_globals.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/node_modules/swiper/modules/pagination.css");
